const view = {

	init() {

		// Verkrijg de fetchUrl uit het data-fetch-url attribuut van het element
		const fetchUrl = document.querySelector('[data-fetch-url]').getAttribute('data-fetch-url');

		// Functie om het resultaat van de fetch te tonen
		function showResult(result) {
			// Verberg het animatie-element
			document.querySelector('[data-fetch-el-animation]').classList.add('d-none');
			// Toon het element met het bijbehorende resultaat
			document.querySelector('[data-fetch-el-' + result + ']').classList.remove('d-none');
		}

		// Maak een nieuw XMLHttpRequest-object
		const xhr = new XMLHttpRequest();

		// Open het verzoek met de GET-methode en de fetchUrl
		xhr.open('GET', fetchUrl, true);

		// Functie om te controleren of het verzoek is geladen
		xhr.onload = function() {
			// Controleer of de status van het verzoek succesvol is
			if (xhr.status >= 200 && xhr.status < 400) {
				// Converteer het ontvangen JSON-antwoord naar een JavaScript-object
				let data = JSON.parse(xhr.responseText);
				// Stel het 'response'-attribuut van het .failure-element in op het ontvangen antwoord
				document.querySelector('[data-fetch-el-failure]').setAttribute('response', xhr.responseText);
				// Controleer of de data niet false, 'lockfile' of 'unknown_file_type' is
				if (data !== false && data !== 'lockfile' && data !== 'unknown_file_type') {
					// Stel een timer in om na 500ms het succesresultaat te tonen en de pagina te vernieuwen
					setTimeout(function() {
						showResult('success');
						// window.location.href = window.location.href; // TODO: Deze regel is uitgecomment omdat hij niet door de eslint kwam. Deze comment mag na enige tijd verwijderd worden
						window.location.reload(true); // Doet hetzelfde als window.location.href = window.location.href
					}, 500);
				} else {
					// Toon het falen van de fetch
					showResult('failure');
				}
			} else {
				// Toon het falen van de fetch
				showResult('failure');
			}
		};

		// Functie om te controleren of er een fout is opgetreden tijdens het verzoek
		xhr.onerror = function() {
			// Toon het falen van de fetch
			showResult('failure');
		};

		// Verstuur het verzoek
		xhr.send();


	}

};

export default view;
